import React from "react";
import NumberFormat from "react-number-format";

export default function ItemTotalComponent({ order }) {
  let total = 0;
  if (order.item.extraPrice) {
    total = order.item.extraPrice * order.qty;
  } else {
    total = order.item.price * order.qty;
  }

  return (
    <NumberFormat
      value={total}
      displayType={"text"}
      thousandSeparator={true}
      prefix={"$"}
      decimalScale={2}
      fixedDecimalScale={true}
    />
  );
}
